import React from "react";

/**
 * AuthLoading Component
 * Displays a loading screen during authentication initialization
 * @param {Object} props
 * @param {string} props.message - Loading message (default: "Loading...")
 * @param {string} props.subtitle - Subtitle text (default: "Initializing...")
 * @param {string} props.logo - Optional logo image source
 * @param {string} props.logoAlt - Alt text for logo (default: "Logo")
 */
const AuthLoading = ({
  message = "Loading...",
  subtitle = "Initializing...",
  logo,
  logoAlt = "Logo",
  texts = {},
}) => {
  const resolvedMessage = texts?.message || message;
  const resolvedSubtitle = texts?.subtitle || subtitle;
  const resolvedLogoAlt = texts?.logoAlt || logoAlt;

  return (
    <div className="flex min-h-screen items-center justify-center bg-black">
      <div className="text-center">
        {logo && (
          <div className="mx-auto mb-8 flex items-center justify-center">
            <img
              className="h-6 w-auto max-w-sm animate-pulse"
              src={logo}
              alt={resolvedLogoAlt}
            />
          </div>
        )}

        <div className="flex items-center justify-center space-x-2">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-blue-500"></div>
          <span className="text-lg font-normal text-white">
            {resolvedMessage}
          </span>
        </div>

        <p className="mt-4 text-sm text-gray-400">{resolvedSubtitle}</p>
      </div>
    </div>
  );
};

export default AuthLoading;
